import React, { CSSProperties, useState, useEffect } from "react"
import Layout from "../../Layout"
import CatalogsLayout from "Components/CatalogsLayout"
import Grid, { TextFilter, SelectColumnFilter, NumberFilter, } from "Components/Grid"
import CatalogsModal from "Components/CatalogsModal"
import Buttons from "../../Components/Buttons"
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux"
import { addView, getViews, updateView } from "actions/vista"
import FormVista from "Forms/Vista"
import { IView } from "Interfaces/IView"
import ConfirmationModal from "Components/ConfirmationModal"
import { validateForm } from "../../utils"

const Vista = () => {
    const defaultItem = {
        idVista: 0,
        codigoVista: "",
        descripcion: "",
        descripcionCorta: "",
        descripcionMenu: "",
        descripcionToolTip: "",
        orden: 0,
        idVistaPadre: 0,
        idTipoReporte: 0,
        idTipoVista: 0,
        multivista: false,
        url: "",
        rutaReporte: "",
        tipo: false,
        imagen: "",
        idEstatus: 1,
    }

    const [title] = useState("Vistas")
    const [open, setOpen] = useState<boolean>(false)
    const [openConfirm, setOpenConfirm] = useState<boolean>(false)
    const [action, setAction] = useState<string>("")
    const [views, setViews] = useState<any>()
    const [errors, setErrors] = useState<IView>({})
    const [formValues, setFormValues] = useState<any>({})
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(true);
    const [viewsParent, setViewsParent] = useState([])
    const dispatch: Dispatch = useDispatch()

    const { catalogs } = useSelector((state: any) => state.theme)
    const { btnSimple } = useSelector((state: any) => state.theme)

    const styles: CSSProperties = {
        fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
        backgroundColor: catalogs.background
    }

    const loadViews = () => {
        getViews(0, '0').then((res) => {
            if (res) setViews(res)
            setIsLoadingGrid(false);
        })
    }

    const handleViewsParent = (idTipoVista: any) => {
        getViews(0, '0').then((res) => {
            if (res) {
                if (idTipoVista <= 1) {
                    res = res.filter((item: any) => (item.idVista === 0))
                }
                if (idTipoVista == 2) {
                    res = res.filter((item: any) => (item.idTipoVista === 1))
                }

                res.unshift({
                    idVista: 0,
                    descripcion: "Seleccionar"
                })

                setViewsParent(res.map((e: any) => {
                    return {
                        value: e.idVista,
                        text: e.descripcion
                    }
                }))
            }
        })
    }

    useEffect(() => {
        loadViews()
    }, [])

    const handleAddClick = () => {
        setAction("add")
        setErrors({})
        setFormValues(defaultItem)
        handleViewsParent(defaultItem.idTipoVista)
        setOpen(true)
    }

    const handleView = (item: any) => {
        setFormValues(item)
        setAction("view")
        setOpen(true)
    }

    const handleEdit = (item: any) => {
        setAction("edit")
        setErrors({})
        setFormValues(item)
        handleViewsParent(item.idTipoVista)
        setOpen(true)
    }

    const handleStatus = (item: any) => {
        item.idEstatus = item.idEstatus === 1 ? 0 : 1
        setFormValues(item)
        setOpenConfirm(true)
    }

    const handleConfirm = () => {
        setIsLoading(true)
        let form = new FormData()
        for (let key in formValues) {
            form.append(key, formValues[key])
        }
        updateView(formValues.idVista, form, false, true).then((res) => {
            if (res) {
                loadViews()
                setOpenConfirm(false)
                dispatch({
                    type: "REMOVE_VIEW_LIST",
                })
            }
            setIsLoading(false)
        })
    }

    const handleCancelConfirm = () => {
        setOpenConfirm(false)
        loadViews()
    }

    const handleOnChange = (e: any) => {
        let value = e.target.value
        let id = e.target.id

        let itemError: any = errors
        delete itemError[id]
        setErrors(itemError)

        if (id === "idTipoVista") {
            handleViewsParent(value)
        }
        setFormValues({
            ...formValues,
            [id === "_inputFile" ? "image" : id]:
                id === "_inputFile" ? e.target.files[0] : value,
            [id === "_inputFile" ? "imagen" : id]:
                id === "_inputFile" ? e.target.files[0].name : value,
        })
    }

    const handleAccept = () => {
        if (!handleValidation()) {
            return false
        }
        setIsLoading(true)
        if (action === "add") {
            let form = new FormData()
            for (let key in formValues) {
                form.append(key, formValues[key])
            }
            addView(form, false).then((res) => {
                if (res) {
                    loadViews()
                    setOpen(false)
                    setFormValues({})
                    dispatch({
                        type: "REMOVE_VIEW_LIST",
                    })
                }
                setIsLoading(false)
            })
        }
        if (action === "edit") {
            debugger
            let form = new FormData()
            for (let key in formValues) {
                form.append(key, formValues[key])
            }
            updateView(formValues.idVista, form, false).then((res) => {
                if (res) {
                    loadViews()
                    setOpen(false)
                    setFormValues({})
                    dispatch({
                        type: "REMOVE_VIEW_LIST",
                    })
                }
                setIsLoading(false)
            })
        }
    }

    const handleValidation = () => {
        let isValid = validateForm({
            schema: {
                codigoVista: {
                    message: "Ingrese el código",
                    validate: (value: any) => {
                        if (value.length > 10) {
                            return {
                                valid: false,
                                message: "La longitud del campo no puede ser mayor a 10 dígitos"
                            }
                        }
                        return {
                            valid: true,
                            message: ""
                        }
                    }
                },
                descripcion: { message: "Ingrese la descripción" },
                descripcionMenu: { message: "Ingrese la descripción menu" },
                url: {
                    message: "Es requerida la url para tipo Vista",
                    optional: parseInt(formValues.idTipoVista) === 3 ? false : true,
                },
                idTipoVista: { message: "Selecciona el tipo de vista" },
                idEstatus: { message: "Selecciona el estatus" },
                image: {
                    message: "Selecciona una imagen",
                    optional: true,
                    validate: (value: any) => {
                        let rgx = /\.(gif|jpe?g|png)$/i
                        let match = value.name.match(rgx)

                        if (match === null) {
                            return {
                                valid: false,
                                message: "Formato de imagen no válido (.png .jpg)"
                            }
                        }

                        if (parseFloat((value.size / (1024 * 1024)).toFixed(2)) > 5) {
                            return {
                                valid: false,
                                message: "El peso de la imagen rebasa los 5MB soportados"
                            }
                        }

                        return {
                            valid: true,
                            message: ""
                        }
                    }
                }
            },
            values: formValues,
        })
        if (Object.keys(isValid).length) {
            setErrors({ ...isValid })
            return false
        }
        return true
    }

    const handleCancel = () => {
        setOpen(false)
        loadViews()
    }

    const columns = [
        {
            accessor: "codigoVista",
            Header: "Código",
            Filter: TextFilter,
            filter: "text",
        },
        {
            accessor: "descripcionMenu",
            Header: "Descripción Menu",
            Filter: TextFilter,
            filter: "text",
        },
        {
            accessor: "descripcion",
            Header: "Descripción",
            Filter: TextFilter,
            filter: "text",
        },
        {
            accessor: "vistaPadre",
            Header: "Padre",
            Filter: TextFilter,
            filter: "text",
        },
        {
            accessor: "tipoVista",
            Header: "Tipo",
            Filter: SelectColumnFilter,
            filter: "text",
        },
        {
            accessor: "estatus",
            Header: "Estatus",
            Filter: SelectColumnFilter,
            filter: "includes",
        },
    ]

    const config: any = {
        actions: [
            {
                action: "view",
                tooltip: "Detalles",
                visible: false,
                handle: handleView,
                color: "#0079ab",
                icon: "search",
            },
            {
                action: "edit",
                tooltip: "Editar",
                visible: true,
                handle: handleEdit,
                color: "#ffb300",
                icon: "edit",
            },
            {
                action: "status",
                tooltip: "Estatus",
                visible: true,
                handle: handleStatus,
                color: "#00a176",
                icon: "check",
                isStatus: "idEstatus",
                colorNegative: "#f15642",
                iconNegative: "clear",
            },
        ],
    }

    return (
        <Layout theme={styles}>
            <>
                <CatalogsLayout bannerTitle={title}>
                    <>
                        <Grid columns={columns} data={views || []} config={config} isLoading={isLoadingGrid}>
                            <Buttons
                                title={"Nueva Vista"}
                                type={"add-catalog"}
                                config={btnSimple}
                                handleClick={handleAddClick}
                            />
                        </Grid>
                        {open && (
                            <CatalogsModal
                                open={open}
                                action={action}
                                title={title}
                                modalSize={action === "view" ? "md" : "lg"}
                                isLoading={isLoading}
                                handleAcceptClick={handleAccept}
                                handleCancelClick={handleCancel}>
                                <FormVista
                                    item={formValues}
                                    action={action}
                                    errors={errors}
                                    viewsParent={viewsParent}
                                    handleOnChange={handleOnChange}
                                />
                            </CatalogsModal>
                        )}
                        {openConfirm && (
                            <ConfirmationModal
                                open={openConfirm}
                                description={`¿Está seguro de ${formValues.idEstatus === 1 ? "activar" : "desactivar"
                                    } la vista?`}
                                modalSize={"sm"}
                                isLoading={isLoading}
                                handleConfirmClick={handleConfirm}
                                handleCancelClick={handleCancelConfirm}></ConfirmationModal>
                        )}
                    </>
                </CatalogsLayout>
            </>
        </Layout>
    )
}

export default Vista
